const BASE_URL = '/free-shipping';

export const FREE_SHIPPING_ROUTES = {
  freeShippingList: BASE_URL,
  newFreeShipping: `${BASE_URL}/new`,
  editFreeShipping: `${BASE_URL}/edit/:id`,
};
